"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhoneNumber = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function getPhoneNumber(phone = '') {
    const { general_settings } = (0, checkout_frontend_library_1.getOrderInitialData)();
    if (general_settings.checkout_process.phone_number_required && (0, src_1.isObjectEmpty)({ phone })) {
        return '1111111111';
    }
    else {
        return phone;
    }
}
exports.getPhoneNumber = getPhoneNumber;
